import useMedia from 'use-media';
import IndividualCarroucel from './individualCarroucel';
import { bodyText1, bodyText2, bodyText3, title1, title2, title3 } from './text';
import React from 'react';

function CarroucelMain(props) {
    /* eslint-disable react/prop-types */
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');

    const carroucelImg1 = [
        {
            url: 'img/pickupCafeguy.png'
        },
    ];
    const carroucelImg2 = [
        {
            url: 'img/cafeBags.jpg'
        }
    ];
    const carroucelImg3 = [
        {
            url: 'img/HappyDelivery.png'
        }
    ];

    return (
        <div>
            {isLargeScreen && 
                <div id="coffeCarroucel" style={{ display: "flex", justifyContent: "space-around", flexFlow: "row wrap" }}>
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title1} 
                        bodyText={bodyText1} carroucelImg={carroucelImg1} arrows="white" url="/localfarms" fontSize={props.fontSize} />
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title2} 
                        bodyText={bodyText2} carroucelImg={carroucelImg2} arrows="black" url="/perfectCoffee" fontSize={props.fontSize}/>
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title3}
                        bodyText={bodyText3} carroucelImg={carroucelImg3} arrows="black" url="/customizeYourOrder" fontSize={props.fontSize}/>
                </div>
            }
            {isSmallScreen &&
                <div id="coffeCarroucel" style={{ display: "flex", justifyContent: "space-around", flexFlow: "row wrap" }}>
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title1} 
                        bodyText={bodyText1} carroucelImg={carroucelImg1} arrows="white" url="/localfarms" fontSize={props.fontSize}/>
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title2} 
                        bodyText={bodyText2} carroucelImg={carroucelImg2} arrows="black" url="/perfectCoffee" fontSize={props.fontSize}/>
                    <IndividualCarroucel isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} title={title3}
                        bodyText={bodyText3} carroucelImg={carroucelImg3} arrows="black" url="/customizeYourOrder" fontSize={props.fontSize}/>
                </div>
            }
       </div>
    );
}

export default CarroucelMain;
